import type { StainDto } from '../api/companions';

/** LRU of snapshot blob URLs. A Map keeps insertion order, so re-inserting on read makes it LRU. */
export function createSnapshotCache(cap: number, revoke: (url: string) => void) {
  const m = new Map<string, string>();
  return {
    get(key: string) {
      const v = m.get(key);
      if (v !== undefined) { m.delete(key); m.set(key, v); }
      return v;
    },
    set(key: string, url: string) {
      if (m.has(key)) m.delete(key);
      m.set(key, url);
      while (m.size > cap) {
        const [k, v] = m.entries().next().value as [string, string];
        m.delete(k);
        revoke(v);
      }
    },
    size: () => m.size,
  };
}

export const stainsKey = (stains: StainDto[]): string =>
  stains.map((s) => `${s.seed}:${s.x.toFixed(3)}:${s.y.toFixed(3)}:${s.scale.toFixed(3)}:${s.rot}:${s.tone}`).join('|');
